export function getFullUrl(guiBackendRootEndpoint: string, api: string) {
  return guiBackendRootEndpoint + '/' + api;
}
